import { useState } from 'react';
import { makeStyles } from '@material-ui/styles';

import { Text, MainButton, Settings, Clock } from '@bizzabo/design-system';
import { UserPreview } from '@bizzabo/entities';

import { useUserSettings } from '../../../../settingsNav';

interface ZeroAvailableTimesProps {
    otherAttendee: UserPreview;
    refetchScheduledMeetingTimes?: () => void;
}

const ZeroAvailableTimes: React.FC<ZeroAvailableTimesProps> = ({
    otherAttendee,
    refetchScheduledMeetingTimes = () => {},
}) => {
    const classes = useStyles();
    const { openScheduledMeetings } = useUserSettings();
    const [isRetryBtnShow, setIsRetryBtnShow] = useState(false);

    const openSettings = () => {
        setIsRetryBtnShow(true);
        openScheduledMeetings();
    };

    return (
        <div className={classes.container}>
            <Clock />
            <Text variant="t40" className={classes.title}>
                Create more availability
            </Text>
            <Text variant="t61" className={classes.text}>
                {`You and ${otherAttendee.firstName} currently don't have any mutual availability. Add more availability to your calendar by going to your meetings preferences.`}
            </Text>
            <MainButton
                className={classes.btnSettings}
                onClick={openSettings}
                before={<Settings className={classes.settingsIcon} />}
            >
                My meeting preferences
            </MainButton>
            {isRetryBtnShow && (
                <MainButton
                    variant="fill"
                    className={classes.retryBtn}
                    onClick={refetchScheduledMeetingTimes}
                >
                    Retry
                </MainButton>
            )}
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '12vh',
            [theme.breakpoints.up('sm')]: {
                paddingTop: '20vh',
            },
        },
        title: {
            marginTop: 8,
            textAlign: 'center',
            color: theme.customization.background.G10,
        },
        text: {
            margin: '16px 0 20px',
            textAlign: 'center',
            color: theme.customization.background.G10,
        },
        btnSettings: {
            ...theme.typography.t80,
            height: 24,
            padding: '0 13px',
        },
        settingsIcon: {
            width: 13,
            height: 13,
        },
        retryBtn: {
            ...theme.typography.t80,
            marginTop: 10,
            padding: '3px 24px',
        },
    }),
    { classNamePrefix: ZeroAvailableTimes.name }
);

export default ZeroAvailableTimes;
